import { sortByItemTypeOrdinal } from 'helpers/menuPreview';
import { MenuData } from 'components/MenuManagement/types';

export function getMatchingItems(
  categoryUuid: string,
  menu: MenuData,
  searchQuery: string,
): string[] {
  return Object.keys(menu.items ?? {}).filter(itemID => {
    const item = menu.items?.[itemID];
    if (!item) return false;
    return (
      item.parentUuidId === categoryUuid &&
      (!searchQuery ||
        item.name.toLowerCase().includes(searchQuery) ||
        item.description?.toLowerCase().includes(searchQuery))
    );
  });
}

export function filterCategories(
  categoryIds: string[],
  menu: MenuData,
  searchQuery: string,
): string[] {
  const lowercasedQuery = searchQuery.toLowerCase();
  return categoryIds.filter(categoryID => {
    const category = menu.categories?.[categoryID];
    if (!category) return false;

    const matchingItems = getMatchingItems(category.uuid, menu, lowercasedQuery);
    return matchingItems.length > 0;
  });
}

export function getFilteredItems(
  categoryID: string,
  menu: MenuData,
  searchQuery: string | null,
): string[] {
  const category = menu.categories?.[categoryID];
  if (!category) return [];

  const matchingItems = getMatchingItems(category.uuid, menu, searchQuery?.toLowerCase() ?? '');

  return matchingItems.sort(sortByItemTypeOrdinal(menu, 'items'));
}
